module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.28f3ab75.woff2";